import React, { useState, useEffect } from 'react';
import { MdStore } from "react-icons/md";
import { FaSquare, FaPiggyBank, FaUserClock, FaCoins } from "react-icons/fa";
import {  RiSwordFill  } from "react-icons/ri";
import { IoPersonAdd } from "react-icons/io5";
import './Risk_Management.css'


import { AiFillSecurityScan, AiFillSafetyCertificate  } from "react-icons/ai";
import { BsShieldFillExclamation, BsTransparency } from "react-icons/bs";
import { GiSwordsEmblem, GiPayMoney, GiCash } from "react-icons/gi";
import { SiCyberdefenders } from "react-icons/si";
import { LuCalendarClock } from "react-icons/lu";
import { FaMoneyBillWave } from "react-icons/fa";

import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdOutlineCenterFocusWeak } from "react-icons/md";
import { PiStrategyBold, PiIdentificationCardFill } from "react-icons/pi";
import { FaUniversalAccess } from "react-icons/fa6";
import { ImConfused2 } from "react-icons/im";
import { HiMiniUserGroup } from "react-icons/hi2";
import { GrCompliance } from "react-icons/gr";






const Risk_Management = () => {
    


    const goals = [
        {
            goal: 'Risk Management Standards compliance (ISO 31000: 2018 and ISO/IEC 23894:2023)',
            PreGoal:'Goal RM1:',
            description: 'Risk management should address the needs of the organization using an integrated, structured and comprehensive approach. Guiding principles allow an organization to identify priorities and make decisions on how to manage the effects of uncertainty on its objectives. These principles apply to all organizational levels and objectives, whether strategic or operational. Systems and processes usually deploy a combination of various technologies and functionalities in various environments, for specific use cases. Risk management should take into account the whole system, with all its technologies and functionalities, and its impact on the environment and stakeholders. AI systems can introduce new or emergent risks for an organization, with positive or negative consequences on objectives, or changes in the likelihood of existing risks. They also can necessitate specific consideration by the organization. Additional guidance for the risk management principles, framework and processes an organization can implement is provided by this document.',
            appliesTo: 'Where Systems and Processes based on AI are deployed',
            text2: 'NOTE Different International Standards have significantly different definitions of the word “risk.” In ISO 31000:2018 and related International Standards, “risk” involves a negative or positive deviation from the objectives. In some other International Standards, “risk” involves potential negative outcomes only, for example, safety-related concerns. This difference in focus can often cause confusion when trying to understand and properly implement a conformant risk management process.',
            requirements: [
                {
                   letter: 'A',
                   principle: 'Integrated',
                   description: 'Risk management is an integral part of all organizational activities.',
                   implication: 'No specific guidance beyond ISO 31000:2018.'
                },
                {
                    letter: 'B',
                    principle: 'Structured and comprehensive',
                    description: 'A structured and comprehensive approach to risk management contributes to consistent and comparable results.',
                    implication: 'No specific guidance beyond ISO 31000:2018.'
                 },
                 {
                    letter: 'C',
                    principle: 'Customized',
                    description: 'The risk management framework and process are customized and proportionate to the organization’s external and internal context related to its objectives.',
                    implication: 'No specific guidance beyond ISO 31000:2018.'
                 },
                 {
                    letter: 'D',
                    principle: 'Inclusive',
                    description: 'Appropriate and timely involvement of stakeholders enables their knowledge, views and perceptions to be considered. This results in improved awareness and informed risk management.',
                    text3: 'Because of the potentially far-reaching impacts of AI to stakeholders, it is important that organizations seek dialog with diverse internal and external groups, both to communicate harms and benefits, and to incorporate feedback and awareness into the risk management process. Organizations should also be aware that the use of AI systems can introduce additional stakeholders. The areas in which the knowledge, views and perceptions of stakeholders are of benefit include but are not restricted to:',
                    subRequirements: [
                        "Machine learning (ML) in particular often relies on the set of data appropriate to fulfil its objectives. Stakeholders can help in the identification of risks regarding the data collection, the processing operations, the source and type of data, and the use of the data for particular situations or where the data subjects can be outliers.",
                        "The complexity of AI technologies creates challenges related to transparency and explainability of AI systems. The diversity of AI technologies further drives these challenges due to characteristics such as multiple types of data modalities, AI model topologies, and transparency and reporting mechanisms that should be selected per stakeholders’ needs. Stakeholders can help to identify the goals and describe the means for enhancing transparency and explainability of AI systems. In certain cases, these goals and means can be generalized across the use case and different stakeholders involved. In other cases, stakeholder segmentation of transparency frameworks and reporting mechanisms can be tailored to relevant personas (e.g., “regulators”, “business owners”, “model risk evaluators”) per the use case.",
                        "Using AI systems for automated decision-making can directly affect internal and external stakeholders. Such stakeholders can provide their views and perceptions concerning, for example, where human oversight can be needed. Stakeholders can help in defining fairness criteria and also help to identify what constitutes bias in the working of the AI system.",
                    ],
                 },
                 {
                    letter: 'E',
                    principle: 'Dynamic',
                    description: 'Risks can emerge, change or disappear as an organization’s external and internal context changes. Risk management anticipates, detects, acknowledges and responds to those changes and events in an appropriate and timely manner.',
                    text3: 'To implement the guidance provided by ISO 31000:2018, organizations should establish organizational structures and measures to identify issues and opportunities related to emerging risks, trends, technologies, uses and actors related to AI systems. Dynamic risk management is particularly important for AI systems because:',
                    subRequirements: [
                        "The nature of AI systems is itself dynamic, due to continuous learning, refining, evaluating, and validating. Additionally, some AI systems have the ability to adapt and optimize based on this loop, creating dynamic changes on their own.",
                        "Customer expectations around AI systems are high and can potentially change quickly as the systems themselves do.",
                        "Legal and regulatory requirements related to AI are frequently changing and being updated. Integration with the management systems on quality, environmental footprints, safety, healthcare, legal or corporate responsibility, or any combination of these maintained by the organization, can also be considered to further understand and manage AI-related risks to the organization, individuals and societies.",
                    ],
                 },
                 {
                    letter: 'F',
                    principle: 'Best available information',
                    description: 'The inputs to risk management are based on historical and current information, as well as on future expectations. Risk management explicitly takes into account any limitations and uncertainties associated with such information and expectations. Information should be timely, clear and available to relevant stakeholders.',
                    implication: 'Taking into account the expectation that AI affects the way individuals interact with and react to technology, it is advisable for organizations engaged in the development of AI systems to keep track of relevant information available regarding the further uses of the AI systems that they developed, while users of AI systems can maintain records of the uses of those systems throughout the entire lifetime of the AI system. As AI is an emerging technology and constantly evolving, historical information can be limited, and future expectations can change quickly. Organizations should take this into account. The internal use of AI systems should be considered, if any. Tracking the use of AI systems by customers and external users can be limited by intellectual property, contractual or market-specific restrictions. Such restrictions should be captured in the AI risk management process and updated when business conditions warrant revisiting'
                 },
                 {
                    letter: 'G',
                    principle: 'Human and cultural factors',
                    description: 'Human behaviour and culture significantly influence all aspects of risk management at each level and stage.',
                    implication: 'Organizations engaged in the design, development or deployment of AI systems, or any combination of these, should monitor the human and cultural landscape in which they are situated. Organizations should focus on identifying how AI systems or components interact with pre-existing societal patterns that can lead to impacts on equitable outcomes, privacy, freedom of expression, fairness, safety, security, employment, the environment, and human rights broadly.'
                 },
                 {
                    letter: 'H',
                    principle: 'Continual improvement',
                    description: 'Risk management is continually improved through learning and experience.',
                    implication: 'The identification of previously unknown risks related to the use of AI systems should be considered in the continual improvement process. Organizations engaged in the design, development or deployment of AI systems or system components, or any combination of these, should monitor the AI ecosystem for Performance successes, shortcomings and lessons learned, and maintain awareness of new AI research findings and techniques(opportunities for improvement).'
                 },
                

            ]
        },
    ];
 



    const goal = goals[0];


    return (
        <div style={{ backgroundColor: 'rgb(240, 242, 245)', height: '100%' }}>
          <div className='dashcontent'>
            <div>
                <h2>Risk Management</h2>
            </div>
            <h2 className="goal-title">
              <span className="goal-prefix">{goal.PreGoal}</span> <span className="Risk-goal-name">{goal.goal}</span>
            </h2>
            <p className="applies-to">{goal.description}</p>
            {goal.text2 && <i className="applies-to">{goal.text2}</i>}
            <p className="applies-to"><i>Applies when:</i> {goal.appliesTo}</p>
            {/* Requirements Table */}
            <div className="assessmentContainerBox">
              <table className="Risk-assessment-table">
                <thead>
                  <tr>
                    <th className="Risk-requirements-header" colSpan="4">Requirements</th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th></th>
                    <th>Principle</th>
                    <th>Description (as given in ISO 31000:2018, Clause 4)</th>
                    <th>Implications for the development and use of AI</th>
                  </tr>
                </thead>
                <tbody>
                  {goal.requirements.map((requirement, index) => (
                    <tr key={index} className="requirement-row">
                        <td className="requirement-text">
                        <strong>{requirement.letter}</strong>
                        </td>
                        <td>{requirement.principle}</td>
                        <td>{requirement.description}</td>
                         <td>
                            {requirement.implication ? (
                                requirement.implication
                            ) : (
                              
                                
                                requirement.subRequirements && (
                                <>
                                    <span>{requirement.text3}</span>
                                    <ul className="sub-requirements2-list">
                                        {requirement.subRequirements.map((subRequirement, subIndex) => (
                                        <li key={subIndex} className="sub-requirement-item">
                                            {subRequirement}
                                        </li>
                                        ))}
                                    </ul>
                                </>
                                )
                            )}
                        </td>
                    </tr>
                  ))}
                </tbody>
              </table>              
            </div>
          </div>
        </div>
      );
};

    

export default Risk_Management;